PES = PES || {}
PES.Footer = function () {
    var initCollapsiblePanels = function () {
        $("footer .collapse.in").prev(".panel-heading").addClass("active");
        $("footer #footer-menu")
            .on("show.bs.collapse", function (a) {
                $(a.target).prev(".panel-heading").addClass("active");
            })
            .on("hide.bs.collapse", function (a) {
                $(a.target).prev(".panel-heading").removeClass("active");
            });
    };

    var initFooterResponsive = function () {
        var setupResponsive = function () {
            var showPanels = function () {
                $.each($(".responsive-panel"), function (i, element) {
                    if (!$(element).hasClass("in")) {
                        $(element).addClass("in");
                    }
                });
                $.each($(".responsive-panel-heading"), function (i, element) {
                    $(element).css("cursor", "default");
                });};
            var hidePanels = function () {
                $.each($(".responsive-panel"), function (i, element) {
                    if ($(element).hasClass("in")) {
                        $(element).removeClass("in");
                    }
                });

                $.each($(".responsive-panel-heading"), function (i, element) {
                    $(element).css("cursor", "pointer");
                });
            };

            var minDesktopWidth = 1360;
            if (window.innerWidth < minDesktopWidth) {
                hidePanels();
                $(".footer-component > .panel-heading").css("pointer-events", "auto");
            } else {
                showPanels();
                $(".footer-component > .panel-heading").css("pointer-events", "none");
            }
        };

        setupResponsive();

        window.addEventListener("resize", function () { setupResponsive(); });
    };

    var init = function () {
        initCollapsiblePanels();
        initFooterResponsive();
    };

    return {
        init: init
    }
}();